<template>
    <div>
    </div>
</template>

<script>
    

    export default {
        name: "simpleCounselRedirectPage",

        data() {
            return {

            }
        },

        created() {
            this.doRedirect();
        },

        methods: {
            doRedirect() {
                window.location.href = "https://presale.uplus.co.kr/simpleCounsel?spcsJncoId=" + this.$route.query.join_cate;
            },
        },
    }
</script>

<style scoped>

</style>